import React, {useEffect, useState} from 'react';
import MainLayout from "../../layouts/main";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {useFavouritesService} from "../../services/favourites-service";
import {useGlobalNotificationMessage} from "../../context/message";
import CategoryCell from "../../components/category-cell";
import {Link} from "react-router-dom";
import {AppRoutes, SearchTypes} from "../../utils/constants";
import StarRating from "../../components/star-rating";


export default function Following () {

  const [categories, setCategories] = useState([]);
  const [trainers, setTrainers] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const {addErrorMessage} = useGlobalNotificationMessage();

  const favouritesService = useFavouritesService();

  useEffect(() => {
    let promises = [
      favouritesService.getList(),
    ];

    Promise.all(promises).then(async ([favourites = []]) => {
      setCategories(favourites?.categories || []);
      setTrainers(favourites?.trainers || []);
      setLoaded(true);
    }).catch(error => {
      HelperService.handleApiErrors(error, addErrorMessage);
    });
  }, []);

  const TrainerCell = function ({trainer, ...props}) {
    return (<Link to={`${AppRoutes.trainers.path}/${trainer.id}`} className="clickable router-link">
      <div
          className="card clickable text-center d-flex align-items-center rounded-3 py-4 gap-2 mb-4 border-0 hover-cell-effect">
        <div className="rounded-circle bg-cover"
             style={{backgroundImage: `url(${trainer.photo})`, width: '110px', height: '110px'}}></div>
        <div className="px-2">
          <h6>{trainer.name} {trainer.surname}</h6>
          <StarRating rating={trainer.rating} count={trainer.reviews} />
        </div>
      </div>
    </Link>);
  }

  return (
    <>

      <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding-first">
        <div className={"container"}>
          <div className={"row"}>
            <div className={"col-sm-12 col-md-7 col-lg-6"}>
              <h1 className="header-stripe-blue">Following</h1>
              <p>These are your interests and trainers you find interesting</p>
            </div>
          </div>
        </div>
      </Section>

      <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding">
        <div className={"container"}>
          <div className={"row"}>
            <div className={"col-sm-12 col-md-6"}>
              <h2>FitPros</h2>
              <div className="row">
              {trainers?.length > 0 && trainers.map(t => <div key={t.id} className="col-sm-12 col-md-6 col-lg-4"><TrainerCell trainer={t} /></div>)}
              {trainers?.length === 0 && <div className="text-muted p-5 text-center">You are not following any trainers yet. If you find some you're happy with, hit follow to easily keep in touch.</div>}
              </div>
            </div>
            <div className={"col-sm-12 col-md-6"}>
              <h2>Your interests</h2>
              <div className="row">
                {categories?.length > 0 && categories.map(c => <div  key={c.id}
                    className="col-sm-12 col-md-6"><CategoryCell category={c} link={`${AppRoutes.searchEvents.path}?type=${SearchTypes.discover}&categories=[CID]`} /></div>)}
                {categories?.length === 0 &&
                    <div className="text-muted p-5 text-center">You didn't choose any categories that interest you yet.
                      If you do that in your profile, we can show you more personalized results on discover page.</div>}
              </div>
            </div>
          </div>
        </div>
      </Section>

    </>
  );
}

Following.getLayout = function getLayout(page) {
  return (
      <MainLayout>
        {page}
      </MainLayout>
  )
}